import { Box, Grid, Stack } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useContext } from "react";
import { WindowSizeContext } from "../context/WindowSizeProvider";
import LoginForm from "../components/LoginForm";

export default function LandingPage() {
  const { smallScreen } = useContext(WindowSizeContext);

  return (
    <>
      <Helmet>
        <title>NHIDirect</title>
      </Helmet>

      <Stack sx={{
        minHeight: "100vh", position: "relative", overflowY: "auto", overflowX: "hidden", backgroundImage: "linear-gradient(rgba(240,248,252,0.7), rgba(240,248,252,0.7)), url('/home-background.jpeg')",
        backgroundRepeat: "no-repeat", backgroundPosition: "right center", backgroundSize: "cover"
      }}>
        <Grid container columnSpacing={{ md: 8, xs: 2 }} sx={{ position: "relative", px: 8, py: 4, alignItems: "center", height: "100%" }}>
          <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: smallScreen ? 5 : 0 }}>
            <Box>
              <Box component="img" src="/Nhi_logo.png" alt="NHI Direct" sx={{ width: smallScreen ? 240 : 320, mb: 2, }} />
              <Box sx={{ fontSize: smallScreen ? "2.5rem" : "4rem", fontWeight: 700, lineHeight: 1.08, color: "black", mb: 3, }} >
                Where Healthcare <br /> meets Simplicity.
              </Box>
              <Box sx={{ fontSize: "1.25rem", color: "black", }}> Smarter pricing. Seamless service. Faster delivery. </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
            <LoginForm wrapperSX={{ minHeight: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", pr: { md: 10, lg: 23 }, }} />
          </Grid>
        </Grid>
      </Stack>
    </>
  );
}